import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { DriverProcessDetail } from 'app/models/driverProcess.model';
import { DriverProcessService } from 'app/services/driver-process.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseFormComponent } from '../../../base-form.component';
import { DriverProcessComponent } from '../driver-process.component';
import { GenericMapComponent } from '../../../generic-map/generic-map.component';

@Component({
    selector: 'app-driver-process-detail',
    templateUrl: './driver-process-detail.component.html',
    styleUrls: ['./driver-process-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class DriverProcessDetailComponent extends BaseFormComponent implements OnInit {

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    public driverProcessDetailList: Array<DriverProcessDetail>

    private _dataSource: MatTableDataSource<DriverProcessDetail> = undefined;
    public get dataSource(): MatTableDataSource<DriverProcessDetail> {
        return this._dataSource;
    }

    private _displayedColumns = ['containerName', 'carLocation', 'streetDesc','status', 'visitDate'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        public dialogRef: MatDialogRef<DriverProcessComponent>,
        private _spinner: NgxSpinnerService,
        @Inject(MAT_DIALOG_DATA) public data,
        public _driverProcessService: DriverProcessService,
        public _dialog: MatDialog
    ) {
        super()
    }

    async ngOnInit() {

        try {
            this._spinner.show('loading')
            this.driverProcessDetailList = await this._driverProcessService.getDriverProcessDetail(this.data.id)
            
            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);

        }

        await this.updateTableDataSource();
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'streetDesc': return item.container.streetDesc;
                case 'visitDate': return item.visitDate;
                default: return item[property];
            }
        }
    }

    public async onContainerMap(lat:string,lng:string){
        const dialog = this._dialog.open(GenericMapComponent,{
        })
        dialog.componentInstance.latitude=parseFloat(lat);
        dialog.componentInstance.longitude=parseFloat(lng);
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<DriverProcessDetail>(this.driverProcessDetailList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

}
